import React from 'react';
import { Handle, Position } from 'reactflow';

const ConditionNode = ({ data, isConnectable }) => {
  const subline = data.Title !== undefined ? data.Title : '';
  return (
    <div className="wrapper gradient">
      <div className="inner">
        <div className="body">
          <div>
            <div className="title">{data.label}</div>
            {subline && <div className="subline">{subline}</div>}
          </div>
        </div>
        {/* Giriş - Üstten */}
        <Handle id="in" type="target" position={Position.Top} style={{ top: -4, background: '#555' }} isConnectable={isConnectable} />
        {/* True çıkışı - Soldan (yeşil) */}
        <Handle id="true" type="source" position={Position.Left} style={{ left: -4, background: '#4CAF50' }} isConnectable={isConnectable} />
        {/* False çıkışı - Sağdan (kırmızı) */}
        <Handle id="false" type="source" position={Position.Right} style={{ right: -4, background: '#f44336' }} isConnectable={isConnectable} />
      </div>
    </div>
  );
};

export default ConditionNode;

